import api from "../../api/client";
import { API_ROUTE } from "../../api/endpoints";

export async function createRegistry(payload) {
  const payloadAsArray = Array.isArray(payload) ? payload : [payload];
  const { data } = await api.post(API_ROUTE.CREATE_REGISTRY, payloadAsArray);
  return data;
}
